export const leaveWithoutAsking = { leaveWithoutAsking: true } as const;

export function leavesWithoutAsking(state: unknown): boolean {
  return (
    typeof state === 'object' &&
    state !== null &&
    'leaveWithoutAsking' in state &&
    state.leaveWithoutAsking === true
  );
}
